import React, { useEffect, useMemo, useRef, useState } from 'react'

import Subscribe from '../components/Subscribe'
import Footer from '../components/Footer';
import Upcommingexprences from '../components/Upcommingexprences';
import { Search, ChevronDown, MoveRight } from 'lucide-react';
import './Myreviews.css';
import Reviewpopup from './Reviewpopup';
import coldImg from '../assets/images/cold.png';
import attendedBadge from '../assets/images/attended.png';
import doubleleftarrow from '../assets/images/doubleleftarrow.png';
import leftarrow from '../assets/images/leftarrow.png';
import rightarrow from '../assets/images/rightarrow.png';
import doublerightarrow from '../assets/images/doublerightarrow.png';

const Myreviews = () => {
      const PAGE_SIZE = 6;
      const [isReviewOpen, setIsReviewOpen] = useState(false);
      const [searchText, setSearchText] = useState('');
      const [selectedcity, setSelectedcity] = useState('All');
      const [selectedType, setSelectedType] = useState('All');
      const [iscityOpen, setIscityOpen] = useState(false); 
      const [isTypeOpen, setIsTypeOpen] = useState(false);
      const [isDateOpen, setIsDateOpen] = useState(false);
      const [range, setRange] = useState({ start: null, end: null });
      const [displayMonth, setDisplayMonth] = useState(new Date());
      const cityDropdownRef = useRef(null);
      const dateDropdownRef = useRef(null);
      const typeDropdownRef = useRef(null);

      const makeEvent = (dateIso, title, city, type, overrides = {}) => {
          const eventDate = new Date(dateIso);
          return {
              id: overrides.id || null,
              eventId: overrides.eventId || overrides.id || null,
              dateIso,
              dateDay: `${eventDate.getDate()}`,
              dateMonth: eventDate.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
              title,
              city,
              type,
              time: overrides.time || "05:00 PM Onwards",
              imageUrl: overrides.imageUrl || coldImg,
              reviewRating: overrides.reviewRating || 0,
              reviewDescription: overrides.reviewDescription || ''
          };
      };

      const [events, setEvents] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [activeEventId, setActiveEventId] = useState(null);
      const [activeEventDetails, setActiveEventDetails] = useState(null);
      const [expandedReviews, setExpandedReviews] = useState(() => new Set());
      const getStoredUser = () => {
          const raw = localStorage.getItem('user');
          if (!raw) return null;
          try {
              return JSON.parse(raw);
          } catch {
              return null;
          }
      };

         const limitWords = (value, maxWords) => {
        if (!value) return '';
        const words = value.trim().split(/\s+/);
        if (words.length <= maxWords) return value;
        return `${words.slice(0, maxWords).join(' ')}...`;
    };

      const cityOptions = useMemo(() => {
          const values = new Set();
          events.forEach((event) => {
              if (event.city) {
                  values.add(event.city);
              }
          });
          return ['All', ...Array.from(values)];
      }, [events]);

      const nameOptions = useMemo(() => {
          const values = new Set();
          events.forEach((event) => {
              if (event.title) {
                  values.add(event.title);
              }
          });
          return ['All', ...Array.from(values)];
      }, [events]);

      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

      const loadEvents = async () => {
          try {
              const token = localStorage.getItem('token');
              const response = await fetch(`${API_BASE_URL}/api/v1/orders/my-orders?page=1&limit=10`, {
                  headers: {
                      authorization: token ? `Bearer ${token}` : ''
                  }
              });
              const data = await response.json();

              if (!response.ok) {
                  throw new Error(data.message || 'Failed to load events');
              }

              const items = Array.isArray(data.orders) ? data.orders : [];
              const attendedOrders = items.filter((item) => item?.status === 'attended');
              const mapped = attendedOrders.map((item) => {
                  const eventData = item.eventDetails || {};
                  const rawThumbnail = eventData.thumbnail || '';
                  const normalizedThumbnail = rawThumbnail
                      ? rawThumbnail.replace(/^https?:\/\/localhost(:\d+)?/i, API_BASE_URL)
                      : '';
                  const cityLabel = eventData.city
                      || [eventData.city, eventData.state, eventData.country].filter(Boolean).join(', ')
                      || 'city TBA';
                  return makeEvent(
                      eventData.date || item.timestamp || new Date().toISOString(),
                      eventData.title || 'EVENT',
                      cityLabel,
                      'All',
                      {
                          id: eventData._id || item.eventId,
                          eventId: eventData._id || item.eventId,
                          time: eventData.time || (item.timestamp
                              ? new Date(item.timestamp).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
                              : undefined),
                          imageUrl: normalizedThumbnail || rawThumbnail,
                          reviewRating: 0,
                          reviewDescription: ''
                      }
                  );
              });
              const currentUser = getStoredUser();
              const currentUserId = currentUser?._id || currentUser?.id || null;
              const reviewsByEventId = new Map();

              await Promise.all(mapped.map(async (event) => {
                  if (!event.eventId) return;
                  try {
                      const reviewResponse = await fetch(`${API_BASE_URL}/api/v1/review?eventId=${event.eventId}`);
                      const reviewData = await reviewResponse.json();
                      if (!reviewResponse.ok) return;
                      const reviews = Array.isArray(reviewData.reviews) ? reviewData.reviews : [];
                      const myReview = currentUserId
                          ? reviews.find((review) => review?.userId?._id === currentUserId)
                          : null;
                      if (myReview) {
                          reviewsByEventId.set(event.eventId, myReview);
                      }
                  } catch (error) {
                      console.error('Failed to load review', error);
                  }
              }));

              const merged = mapped.map((event) => {
                  const myReview = reviewsByEventId.get(event.eventId);
                  if (!myReview) return event;
                  return {
                      ...event,
                      reviewRating: myReview.rating || 0,
                      reviewDescription: myReview.description || ''
                  };
              });

              setEvents(merged);
          } catch (error) {
              console.error('Failed to load events', error);
          }
      };

      useEffect(() => {
          let isMounted = true;
          const load = async () => {
              await loadEvents();
              if (!isMounted) return;
          };
          load();
          return () => {
              isMounted = false;
          };
      }, []);

      useEffect(() => {
          if (!iscityOpen && !isDateOpen && !isTypeOpen) {
              return undefined;
          }

          const handleOutsideClick = (event) => {
              const target = event.target;
              const isInsidecity = cityDropdownRef.current && cityDropdownRef.current.contains(target);
              const isInsideDate = dateDropdownRef.current && dateDropdownRef.current.contains(target);
              const isInsideType = typeDropdownRef.current && typeDropdownRef.current.contains(target);

              if (!isInsidecity && !isInsideDate && !isInsideType) {
                  setIscityOpen(false);
                  setIsDateOpen(false);
                  setIsTypeOpen(false);
              }
          };

          document.addEventListener('mousedown', handleOutsideClick);
          return () => {
              document.removeEventListener('mousedown', handleOutsideClick);
          };
      }, [iscityOpen, isDateOpen, isTypeOpen]);

      const formatReadableDate = (date) => {
          if (!date) return '';
          return date.toLocaleString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric'
          });
      };

      const formatRangeLabel = () => {
          if (!range.start) return 'Select date range';
          if (range.start && !range.end) return formatReadableDate(range.start);
          return `${formatReadableDate(range.start)} - ${formatReadableDate(range.end)}`;
      };

      const toggleReviewExpansion = (eventId) => {
          setExpandedReviews((prev) => {
              const next = new Set(prev);
              if (next.has(eventId)) {
                  next.delete(eventId);
              } else {
                  next.add(eventId);
              }
              return next;
          });
      };

      const shouldShowReadMore = (text) => {
          if (!text) return false;
          return text.trim().length > 160;
      };

      const handleDateSelect = (selectedDate) => {
          if (!range.start || (range.start && range.end)) {
              setRange({ start: selectedDate, end: null });
              return;
          }
          if (selectedDate < range.start) {
              setRange({ start: selectedDate, end: range.start });
              return;
          }
          setRange({ start: range.start, end: selectedDate });
      };

      const getMonthMatrix = (year, month) => {
          const firstDay = new Date(year, month, 1);
          const startDay = firstDay.getDay();
          const daysInMonth = new Date(year, month + 1, 0).getDate();
          const cells = [];

          for (let i = 0; i < startDay; i += 1) {
              cells.push(null);
          }
          for (let day = 1; day <= daysInMonth; day += 1) {
              cells.push(new Date(year, month, day));
          }
          return cells;
      };

      const applyPreset = (preset) => {
          const today = new Date();
          const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
          const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

          if (preset === 'Today') {
              setRange({ start: today, end: today });
          } else if (preset === 'Yesterday') {
              const yesterday = new Date(today);
              yesterday.setDate(today.getDate() - 1);
              setRange({ start: yesterday, end: yesterday });
          } else if (preset === 'Last 7 days') {
              const start = new Date(today);
              start.setDate(today.getDate() - 6);
              setRange({ start, end: today });
          } else if (preset === 'Last 30 days') {
              const start = new Date(today);
              start.setDate(today.getDate() - 29);
              setRange({ start, end: today });
          } else if (preset === 'This month') {
              setRange({ start: startOfMonth, end: endOfMonth });
          } else if (preset === 'Last month') {
              setRange({ start: lastMonthStart, end: lastMonthEnd });
          } else {
              setRange({ start: null, end: null });
          }
      };

      const filteredEvents = events.filter((event) => {
          const searchValue = searchText.trim().toLowerCase();
          const matchesSearch = !searchValue
              || event.title.replace(/\s+/g, ' ').toLowerCase().includes(searchValue)
              || event.city.toLowerCase().includes(searchValue);
          const matchescity = selectedcity === 'All' || event.city === selectedcity;
          const matchesType = selectedType === 'All' || event.title === selectedType;

          if (!range.start || !range.end) {
              return matchesSearch && matchescity && matchesType;
          }

          const eventDate = new Date(event.dateIso);
          const start = new Date(range.start.getFullYear(), range.start.getMonth(), range.start.getDate());
          const end = new Date(range.end.getFullYear(), range.end.getMonth(), range.end.getDate());
          const matchesDate = eventDate >= start && eventDate <= end;

          return matchesSearch && matchescity && matchesType && matchesDate;
      });

      useEffect(() => {
          setCurrentPage(1);
      }, [searchText, selectedcity, selectedType, range.start, range.end]);

      const totalPages = Math.max(1, Math.ceil(filteredEvents.length / PAGE_SIZE));
      const safePage = Math.min(currentPage, totalPages);
      const pageStart = (safePage - 1) * PAGE_SIZE;
      const pagedEvents = filteredEvents.slice(pageStart, pageStart + PAGE_SIZE);

      const getPageItems = () => {
          if (totalPages <= 5) {
              return Array.from({ length: totalPages }, (_, idx) => idx + 1);
          }
          const pages = new Set([1, totalPages, safePage - 1, safePage, safePage + 1]);
          return Array.from(pages)
              .filter((page) => page >= 1 && page <= totalPages)
              .sort((a, b) => a - b);
      };

      const pageItems = getPageItems();

      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const monthA = new Date(displayMonth.getFullYear(), displayMonth.getMonth(), 1);
      const monthB = new Date(displayMonth.getFullYear(), displayMonth.getMonth() + 1, 1);
      const monthACells = getMonthMatrix(monthA.getFullYear(), monthA.getMonth());
      const monthBCells = getMonthMatrix(monthB.getFullYear(), monthB.getMonth());
  return (
    <>

    {/* section 1 */}
       <div className="esam-upcome-container">
                {/* Header Section */}
                <div className="esam-header-section">
                    <div className="esam-upcoming-badge">My Shared Experiences</div>
                    <div className="esam-header-description">
                        Your reflections from events you’ve attended.
                    </div>
                </div>

                {/* Filter Section */}
                <div className="esam-filter-wrapper">
                    <div className="esam-filter-box" style={{ maxWidth: '280px' }}>
                        <input
                            type="text"
                            className="esam-filter-input"
                            placeholder="Search experiences"
                            value={searchText}
                            onChange={(event) => setSearchText(event.target.value)}
                        />
                        <Search className="esam-filter-icon" size={20} />
                    </div>

                    <div className="esam-filter-box" style={{ maxWidth: '180px' }} ref={cityDropdownRef}>
                        <button
                            type="button"
                            className="esam-filter-dropdown"
                            onClick={() => {
                                setIscityOpen((prev) => !prev);
                                setIsTypeOpen(false);
                                setIsDateOpen(false);
                            }}
                        >
                            <span>{selectedcity === 'All' ? 'Search city' : selectedcity}</span>
                            <ChevronDown size={20} />
                        </button>
                        {iscityOpen && (
                            <div className="esam-filter-menu">
                                {cityOptions.map((city) => (
                                    <button
                                        key={city}
                                        type="button"
                                        className={`esam-filter-option${selectedcity === city ? ' esam-filter-option-active' : ''}`}
                                        onClick={() => {
                                            setSelectedcity(city);
                                            setIscityOpen(false);
                                        }}
                                    >
                                        {city}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="esam-filter-box" style={{ maxWidth: '240px' }} ref={dateDropdownRef}>
                        <button
                            type="button"
                            className="esam-filter-dropdown"
                            onClick={() => {
                                setIsDateOpen((prev) => !prev);
                                setIscityOpen(false);
                                setIsTypeOpen(false);
                            }}
                        >
                            <span>{formatRangeLabel()}</span>
                            <ChevronDown size={20} />
                        </button>
                        {isDateOpen && (
                            <div className="esam-date-picker">
                                <div className="esam-date-sidebar">
                                    <div className="esam-date-sidebar-title">Recently used</div>
                                    {['Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'This month', 'Last month', 'Custom'].map((preset) => (
                                        <button
                                            key={preset}
                                            type="button"
                                            className="esam-date-preset"
                                            onClick={() => applyPreset(preset)}
                                        >
                                            {preset}
                                        </button>
                                    ))}
                                </div>

                                <div className="esam-date-main">
                                    <div className="esam-date-header">
                                        <button
                                            type="button"
                                            className="esam-date-nav"
                                            onClick={() => setDisplayMonth(new Date(displayMonth.getFullYear(), displayMonth.getMonth() - 1, 1))}
                                        >
                                            &#8249;
                                        </button>
                                        <div className="esam-date-months">
                                            <div className="esam-date-month-label">{monthNames[monthA.getMonth()]} {monthA.getFullYear()}</div>
                                            <div className="esam-date-month-label">{monthNames[monthB.getMonth()]} {monthB.getFullYear()}</div>
                                        </div>
                                        <button
                                            type="button"
                                            className="esam-date-nav"
                                            onClick={() => setDisplayMonth(new Date(displayMonth.getFullYear(), displayMonth.getMonth() + 1, 1))}
                                        >
                                            &#8250;
                                        </button>
                                    </div>

                                    <div className="esam-date-calendars">
                                        {[{ month: monthA, cells: monthACells }, { month: monthB, cells: monthBCells }].map((monthData) => (
                                            <div key={monthData.month.toISOString()} className="esam-calendar">
                                                <div className="esam-calendar-weekdays">
                                                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                                        <span key={day}>{day}</span>
                                                    ))}
                                                </div>
                                                <div className="esam-calendar-grid">
                                                    {monthData.cells.map((date, index) => {
                                                        if (!date) {
                                                            return <span key={`${monthData.month.toISOString()}-empty-${index}`} className="esam-calendar-empty" />;
                                                        }
                                                        const isStart = range.start && date.toDateString() === range.start.toDateString();
                                                        const isEnd = range.end && date.toDateString() === range.end.toDateString();
                                                        const isBetween = range.start && range.end && date > range.start && date < range.end;
                                                        return (
                                                            <button
                                                                key={date.toISOString()}
                                                                type="button"
                                                                className={`esam-calendar-day${isStart || isEnd ? ' esam-calendar-day-active' : ''}${isBetween ? ' esam-calendar-day-range' : ''}`}
                                                                onClick={() => handleDateSelect(date)}
                                                            >
                                                                {date.getDate()}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="esam-date-footer">
                                        {/* <div className="esam-date-fields">
                                            <select className="esam-date-custom">
                                                <option>Custom</option>
                                            </select>
                                            <input
                                                type="text"
                                                readOnly
                                                className="esam-date-input"
                                                value={range.start ? formatReadableDate(range.start) : ''}
                                                placeholder="Start date"
                                            />
                                            <input
                                                type="text"
                                                readOnly
                                                className="esam-date-input"
                                                value={range.end ? formatReadableDate(range.end) : ''}
                                                placeholder="End date"
                                            />
                                        </div> */}
                                        <div className="esam-date-actions">
                                            <button
                                                type="button"
                                                className="esam-date-cancel"
                                                onClick={() => {
                                                    setRange({ start: null, end: null });
                                                    setIsDateOpen(false);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="esam-date-apply"
                                                onClick={() => setIsDateOpen(false)}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="esam-filter-box" style={{ maxWidth: '200px' }} ref={typeDropdownRef}>
                        <button
                            type="button"
                            className="esam-filter-dropdown"
                            onClick={() => {
                                setIsTypeOpen((prev) => !prev);
                                setIscityOpen(false);
                                setIsDateOpen(false);
                            }}
                        >
                            <span>{selectedType === 'All' ? 'Events name' : selectedType}</span>
                            <ChevronDown size={20} />
                        </button>
                        {isTypeOpen && (
                            <div className="esam-filter-menu">
                                {nameOptions.map((type) => (
                                    <button
                                        key={type}
                                        type="button"
                                        className={`esam-filter-option${selectedType === type ? ' esam-filter-option-active' : ''}`}
                                        onClick={() => {
                                            setSelectedType(type);
                                            setIsTypeOpen(false);
                                        }}
                                    >
                                        {type}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                  
                </div>

                {/* Events Grid */}
                <div className="esam-events-gridd">
                    {pagedEvents.map((event, index) => (
                        <div key={index} className="esam-event-cart">
                            <img src={attendedBadge} alt="Attended" className="esam-attended-badge" />
                            <div className="esam-card-header">
                                <div style={{ textAlign: "center" }}>
                                    <div className="esam-date-container">
                                        <span className="esam-date-day">{event.dateDay}</span>
                                        <span className="esam-date-month">{event.dateMonth}</span>
                                    </div>
                                    <h3 className="esam-card-tit">{event.title}</h3>
                                </div>
                                <div className="esam-card-image-wrapper">
                                    <img src={event.imageUrl} alt="Event" className="esam-card-imag" />
                                </div>
                            </div>

                            <div className="esam-meta-tag">
                                <span style={{ fontWeight: 600 }}>
                                        {limitWords(event.city, 3)}
                                    </span> | {event.time}
                            </div>

                            
                            {event.reviewRating || event.reviewDescription ? (
                                <>
                                    <div className="esam-review-stars">
                                        {[1, 2, 3, 4, 5].map((value) => (
                                            <span
                                                key={value}
                                                className={`esam-review-star${value <= event.reviewRating ? ' esam-review-star-filled' : ''}`}
                                            >
                                                ★
                                            </span>
                                        ))}
                                    </div>
                                    {event.reviewDescription && (
                                        <>
                                            <p
                                                className={`esam-review-desc${expandedReviews.has(event.eventId || event.id) ? ' esam-review-desc-expanded' : ''}`}
                                            >
                                                {event.reviewDescription}
                                            </p>
                                            {shouldShowReadMore(event.reviewDescription) && (
                                                <button
                                                    type="button"
                                                    className="esam-review-readmore"
                                                    onClick={() => toggleReviewExpansion(event.eventId || event.id)}
                                                >
                                                    {expandedReviews.has(event.eventId || event.id) ? 'Read less' : 'Read more'}
                                                </button>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <button
                                    className="esam-leave-review-btn"
                                    onClick={() => {
                                        setActiveEventId(event.eventId || event.id);
                                        setActiveEventDetails(event);
                                        setIsReviewOpen(true);
                                    }}
                                >
                                    Leave Review
                                </button>
                            )}

                         
                        </div>
                    ))}
                </div>

                {/* Pagination Section */}
                {filteredEvents.length > 0 && totalPages > 1 && (
                    <div className="esam-pagination-wrapper">
                        <div className="esam-pagination-container">
                            <button
                                className="esam-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage(1)}
                                disabled={safePage === 1}
                            >
                                <img src={doubleleftarrow} alt="Double Left Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>

                            <button
                                className="esam-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                                disabled={safePage === 1}
                            >
                                <img src={leftarrow} alt="Left Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>

                            <div className="esam-pagination-list">
                                {pageItems.map((page, idx) => {
                                    const prev = pageItems[idx - 1];
                                    const showDots = prev && page - prev > 1;
                                    return (
                                        <React.Fragment key={page}>
                                            {showDots && <span className="esam-pagination-dots">...</span>}
                                            <button
                                                type="button"
                                                className={`esam-pagination-item${page === safePage ? ' esam-active' : ''}`}
                                                onClick={() => setCurrentPage(page)}
                                            >
                                                {page}
                                            </button>
                                        </React.Fragment>
                                    );
                                })}
                            </div>

                            <button
                                className="esam-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                                disabled={safePage === totalPages}
                            >
                                <img src={rightarrow} alt="Right Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>

                            <button
                                className="esam-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage(totalPages)}
                                disabled={safePage === totalPages}
                            >
                                <img src={doublerightarrow} alt="Double Right Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>
                    </div>
                )}

            </div>

   {/* next section   */}
    {isReviewOpen && (
        <Reviewpopup
            onClose={() => setIsReviewOpen(false)}
            onSubmit={(review) => {
                setIsReviewOpen(false);
                loadEvents();
            }}
            eventId={activeEventId}
            eventTitle={activeEventDetails?.title}
            eventDate={activeEventDetails?.dateIso}
            eventcity={activeEventDetails?.city}
        />
    )}
    <Upcommingexprences />
      {/* <Subscribe />
      <Footer /> */}
    </>
  )
}

export default Myreviews
